$(document).ready(function(){
    'use strict'

    const windowWidth = window.innerWidth
	const hash = window.location.hash

    //Реализация табов
    $('.tabs').each(function() {
        let ths = $(this);
        let tabsTop = ths.find('.tabs__top').first();
        let tabsContent = ths.find('.tabs__content').first();
        console.log(tabsContent)
		tabsContent.children('.tabs__item').not(':first').hide();
        // const allTabsName = ths.find('.tabs__name');

        // allTabsName.each(function () {
        //     $(this).attr('data-offset', $(this).offset().left)
        // })

		tabsTop.find('.tabs__list').first().children('.tabs__name').on('click',function() {

        	let title = $('.js-footer-title')
			let dataId = $(this).attr('data-id')
			dataId !== undefined ? title.text('Задать вопрос') : title.text('Как оформить продукт')

            // if (windowWidth < 650) {
            // const boxList = $(this).parents('.tabs__box-list')
            // console.log(444, boxList.width())

            // boxList.scrollLeft($(this).offset().left)
            // boxList.stop().animate({
            //     scrollLeft: $(this).attr('data-offset') - 20 - (boxList.width() / 2) + (($(this).width()) / 2)
            // });
            // }
			tabsTop.find('.tabs__list').first().children('.tabs__name').removeClass('active').eq($(this).index()).addClass('active');
			tabsContent.children('.tabs__item').hide().eq($(this).index()).fadeIn()
        }).eq(0).addClass('active');
    });

	if(hash){
		$('.tabs__item').each(function(){
			$(this).hide()
		})
		$('.tabs__name').each(function(){
			$(this).removeClass('active')
		})
		$(`[data-id='${hash}']`).addClass('active')
		$(hash).show()
	}
});
